import React, { FC } from 'react';

import { useTranslations } from 'context/translations';
import { LandingPageLinkKeys, LandingPageTextKeys } from 'service';
import { IconLogo, IconLogoEngText } from 'icons';
import { LocaleSwitcher } from 'components/language';
import Markdown from 'components/Markdown/Markdown';

import styles from './Footer.module.css';

export const Footer: FC = () => {
  const { t, link, translationsMap } = useTranslations();

  return (
    <footer className={styles.wrapper}>
      <div className={styles.container}>
        <div>
          <a
            href={link(LandingPageLinkKeys.MainLink)}
            target="_blank"
            rel="noreferrer"
          >
            <IconLogo className={styles.logo_icon} id="2" />
            <IconLogoEngText
              className={styles.logo_text}
              aria-label="Ornament"
            />
          </a>
        </div>
        <div>{t(LandingPageTextKeys.FooterAddress)}</div>
        <div>
          <Markdown
            content={translationsMap[LandingPageTextKeys.FooterDisclaimer].text}
            className={styles.style_text}
          />
        </div>
      </div>
      <div className={styles.container}>
        <div />
        <div>
          <LocaleSwitcher />
        </div>
        <div />
      </div>
    </footer>
  );
};
